var _regeneratorRuntime = require("/opt/build/repo/node_modules/@babel/runtime/regenerator");

var _asyncToGenerator = require("/opt/build/repo/node_modules/@babel/runtime/helpers/asyncToGenerator");

var _classCallCheck = require("/opt/build/repo/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/opt/build/repo/node_modules/@babel/runtime/helpers/createClass");

var RPC = require('../lib/rpc');

var _require = require('../lib/structs'),
    Tx = _require.Tx;

var TxHandler = require('./tx_handler');

var Callback = require('./callback');

var Base58 = require('bs58');

var defaultConfig = {
  gasRatio: 1,
  gasLimit: 2000000,
  delay: 0,
  expiration: 90,
  defaultLimit: "unlimited"
};
/**
 * IOST开发工具，可以帮忙发交易
 * @constructor
 * @param {object}config - 这个iost的配置
 * @param {HTTPProvider} - provider
 */

var IOST =
/*#__PURE__*/
function () {
  "use strict";

  function IOST(config) {
    _classCallCheck(this, IOST);

    this.config = defaultConfig;

    if (!config) {
      return;
    }

    Object.assign(this.config, config);
    this.rpc = undefined;
    this.account = undefined;
    this.serverTimeDiff = 0;
  }
  /**
   * 调用智能合约ABI
   * @param {string}contract - 智能合约ID或者域名
   * @param {string}abi - 智能合约ABI
   * @param {Array}args - 智能合约参数数组
   * @returns {Tx}
   */


  _createClass(IOST, [{
    key: "callABI",
    value: function callABI(contract, abi, args) {
      var t = new Tx(this.config.gasRatio, this.config.gasLimit);
      t.addAction(contract, abi, JSON.stringify(args));
      t.setTime(this.config.expiration, this.config.delay, this.serverTimeDiff);
      t.addApprove("*", this.config.defaultLimit);
      return t;
    }
    /**
     * 转账
     * @param {string}token - token名
     * @param {string}from - 付款人
     * @param {string}to - 收款人
     * @param {string}amount - 金额
     * @param {string}memo - 转账备注
     * @returns {Tx}
     */

  }, {
    key: "transfer",
    value: function transfer(token, from, to, amount) {
      var memo = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : "";
      var t = this.callABI("token.iost", "transfer", [token, from, to, amount, memo]);
      t.addApprove("*", this.config.defaultLimit);
      t.addApprove("iost", amount);
      return t;
    }
    /**
     * 新建账号
     * @param {string}name - 用户名
     * @param {string}creator - 帐号创建者的用户名
     * @param {string}ownerkey - 用户的owner key
     * @param {string}activekey - 用户的active key
     * @param {number}initialRAM - 用户初始RAM
     * @param {number}initialGasPledge - 用户初始IOST质押
     * @returns {Tx}
     */

  }, {
    key: "newAccount",
    value: function newAccount(name, creator, ownerkey, activekey, initialRAM, initialGasPledge) {
      if (!this._checkPublicKey(ownerkey) || !this._checkPublicKey(activekey)) throw "error public key";
      var t = new Tx(this.config.gasRatio, this.config.gasLimit);
      t.addAction("auth.iost", "signUp", JSON.stringify([name, ownerkey, activekey]));

      if (initialRAM > 10) {
        t.addAction("ram.iost", "buy", JSON.stringify([creator, name, initialRAM]));
      }

      if (initialGasPledge > 0) {
        t.addAction("gas.iost", "pledge", JSON.stringify([creator, name, initialGasPledge + ""]));
      }

      t.setTime(this.config.expiration, this.config.delay, this.serverTimeDiff);
      t.addApprove("*", this.config.defaultLimit);
      return t;
    }
  }, {
    key: "_checkPublicKey",
    value: function _checkPublicKey(key) {
      var b = Base58.decode(key);
      return b.length === 32;
    }
    /**
     * 直接发送交易
     * @param tx
     * @constructor
     */

  }, {
    key: "signAndSend",
    value: function signAndSend(tx) {
      var cb = new Callback(this.currentRPC.transaction);
      var hash = "";
      var self = this;
      self.currentAccount.signTx(tx);
      setTimeout(function () {
        self.currentRPC.transaction.sendTx(tx).then(function (data) {
          hash = data.hash;
          cb.pushMsg("pending", hash);
          cb.hash = hash;
        }).catch(function (e) {
          cb.pushMsg("failed", e);
        });
      }, 50);
      return cb;
    }
    /**
     * 钱包预留接口，可以获得来自钱包的账户
     */

  }, {
    key: "currentAccount",
    value: function currentAccount() {
      return this.currentAccount;
    }
    /**
     * 钱包预留接口，可以获得来自钱包的provider
     */

  }, {
    key: "currentRPC",
    value: function currentRPC() {
      return this.currentRPC;
    }
    /**
     * set a RPC to this iost
     * @param {RPC}rpc - rpc created by hand
     */

  }, {
    key: "setRPC",
    value: function () {
      var _setRPC = _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee(rpc) {
        var clientTime, nodeInfo;
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                this.currentRPC = rpc;
                clientTime = new Date().getTime() * 1e6;
                _context.next = 4;
                return this.currentRPC.net.getNodeInfo();

              case 4:
                nodeInfo = _context.sent;
                this.serverTimeDiff = nodeInfo.server_time - clientTime;
                console.log(this.serverTimeDiff);

              case 7:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function setRPC(_x) {
        return _setRPC.apply(this, arguments);
      }

      return setRPC;
    }()
  }, {
    key: "setAccount",

    /**
     * set an account to this iost
     * @param {Account}account - rpc created by hand
     *
     */
    value: function setAccount(account) {
      this.currentAccount = account;
    }
  }]);

  return IOST;
}();

module.exports = IOST;